import { formatUserRoles } from "@/lib/ui/admin";
import type { SessionRole } from "@/lib/auth/types";

export const APPEARANCE_COOKIE = "pinwiki_appearance";

export type AppearanceMode = "LIGHT" | "SYSTEM";

export const profileCopy = {
  nav: "Профиль",
  title: "Профиль",
  description: "Учётная запись в этой организации.",
  accountTitle: "Учётная запись",
  organizationLabel: "Организация",
  emailLabel: "Email",
  roleLabel: "Роль",
  save: "Сохранить",
  pending: "Сохраняем…",
  saved: "Имя сохранено",
  errorTitle: "Профиль",
  denied: "Нужно войти",
  invalidName: "Укажите имя",
  nameLabel: "Имя",
  nameHelp: "Так вас видят коллеги в списках и в доступе к документам.",
  appearanceLabel: "Тема",
  appearanceHelp: "Светлая всегда. «Как в системе» следует за оформлением устройства.",
  appearanceLight: "Светлая",
  appearanceSystem: "Как в системе",
  logout: "Выйти",
} as const;

export function profileHref(): string {
  return "/profile";
}

export function parseProfileName(
  raw: string,
): { ok: true; value: string } | { ok: false; error: string } {
  const name = raw.trim().replace(/\s+/g, " ");
  if (!name) {
    return { ok: false, error: profileCopy.invalidName };
  }
  if (name.length > 80) {
    return { ok: false, error: profileCopy.invalidName };
  }
  return { ok: true, value: name };
}

export function parseAppearanceMode(
  raw: string | null | undefined,
): AppearanceMode {
  return raw === "SYSTEM" ? "SYSTEM" : "LIGHT";
}

export function carbonThemeFor(
  mode: AppearanceMode,
  prefersDark: boolean,
): "white" | "g100" {
  return mode === "SYSTEM" && prefersDark ? "g100" : "white";
}

export function profileRolesLabel(roles: SessionRole[]): string {
  return formatUserRoles(roles);
}
